export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export const GET = "GET";
export const POST = "POST";
export const PUT = "PUT";

export const API_BASE_URL = "https://comprartodo.com/api-refugio/";